import _ from 'underscore';
var Backbone = require('backbone');
import DialogService from '../../../base/dialog_service';
import CostCentreGroupCollection from '../../collections/costcentregroup';
import AccountModel from '../../models/account';

const GroupItemView = Marionette.ItemView.extend({
  template: require('../../templates/group_list_item.html'),

  ui: {
    item: 'li'
  },

  events: {
    'click @ui.item': 'selected'
  },

  other_collection: null,

  initialize() {
    this.model = this.getOption('model');
    this.collection = this.getOption('collection');
    this.other_collection = this.getOption('other_collection');
  },

  selected() {
    this.collection.remove(this.model);
    this.other_collection.add(this.model);
  }
});

const BelongsToGroupsAvailableView = Marionette.CollectionView.extend({
  tagName: 'ul',
  childView: GroupItemView,
  childViewOptions: {
    other_collection: null,
    collection: null
  },

  initialize() {
    this.childViewOptions.other_collection = this.getOption('other_collection');
    this.childViewOptions.collection = this.getOption('collection');
  },

  buildChildView(child, ChildViewClass, childViewOptions){
    // build the final list of options for the childView class
    const options = _.extend({ model: child }, childViewOptions);
    // create the child view instance
    const view = new ChildViewClass(options);
    // return it
    return view;
  },
});

const BelongsToGroupsSelectedView = Marionette.CollectionView.extend({
  tagName: 'ul',
  childView: GroupItemView,
  childViewOptions: {
    other_collection: null,
    collection: null
  },

  initialize() {
    this.childViewOptions.other_collection = this.getOption('other_collection');
    this.childViewOptions.collection = this.getOption('collection');
  },

  buildChildView(child, ChildViewClass, childViewOptions){
    // build the final list of options for the childView class
    const options = _.extend({ model: child }, childViewOptions);
    // create the child view instance
    const view = new ChildViewClass(options);
    // return it
    return view;
  },
});

const ImportConfirmView = Marionette.LayoutView.extend({
  template: require('../../templates/create_new_account_dialog.html'),

  ui: {
    errorSection: '.error-messages',
    create_account: '#confirm-create-account-button',
    cancel_button: '.closeButton',
    code: '#id_code',
    name: '#id_name',
    is_active: '#id_is_active',
    is_shared: '#id_is_shared',
    is_donation: '#id_is_donation',
    opening_balance: '#id_opening_balance',
    budget: '#id_budget',
    unit_cost: '#id_unit_cost',
    new_group: '#id_new_group'
  },

  events: {
    'click @ui.create_account': 'saveClicked',
    'click @ui.cancel_button': 'close',
    'click @ui.manage_button': 'manageAccounts',
    'change @ui.code': 'changeFormInput',
    'change @ui.name': 'changeFormInput',
    'change @ui.is_active': 'changeFormCheckbox',
    'change @ui.is_shared': 'changeFormCheckbox',
    'change @ui.is_donation': 'changeFormCheckbox',
    'change @ui.opening_balance': 'changeFormInput',
    'change @ui.budget': 'changeFormInput',
    'change @ui.unit_cost': 'changeFormInput',
    'change @ui.new_group': 'changeFormInput'
  },

  selected_collection: null,

  listOfTakenCodes: [],

  initialize() {
    const links = this.getOption('links');

    this.model = new AccountModel();
    this.model.url = links.costcentre_create;

    this.model.fetch({
      headers: {
        Authorization: `JWT ${this.getOption('token')}`
      },
      success:  (response) => {
        const existingCostcentres = response.changed;

        for(const index in existingCostcentres) {
          const thisCostcentre = existingCostcentres[index];

          if (typeof thisCostcentre === 'object' && thisCostcentre.code !== '') {
            this.listOfTakenCodes.push(thisCostcentre.code);
          }
        }
      }
    });

    this.render();

    this.collection = new Backbone.Collection();
    this.collection.url = links.costcentregroups;

    this.selected_collection = new Backbone.Collection();

    const available = new BelongsToGroupsAvailableView({ collection: this.collection, other_collection: this.selected_collection });
    const selected = new BelongsToGroupsSelectedView({ collection: this.selected_collection, other_collection: this.collection });

    this.addRegions({
      available_rgn: '.ms-selectable',
      selected_rgn: '.ms-selection',
    });

    const that = this;
    this.collection.fetch({
      headers: {
        Authorization: `JWT ${this.getOption('token')}`
      },
      success:  (response) => {
          that.showChildView('available_rgn', available);
          that.showChildView('selected_rgn', selected);
      }
    });
  },

  addErrorMessage(message, element=null) {
    this.ui.errorSection.show();

    const errorMessage = `<li class="error">${message}</li>`;
    this.ui.errorSection.append(errorMessage);

    if (element !== null) {
      $(element).addClass('invalid-input');
    }
  },

  clearErrorMessages() {
    this.ui.errorSection.html('');
    this.ui.errorSection.hide();
  },

  changeFormInput(event) {
    const value = event.currentTarget.value;

    this.model.set(event.currentTarget.name, value);

    if ($(event.currentTarget).hasClass('invalid-input')) {
      $(event.currentTarget).removeClass('invalid-input');
    }

    this.removeExistingFieldErrorMessage(event.currentTarget);
  },

  removeExistingFieldErrorMessage(element) {
    const existingErrorMessage = $(element).parent().find('ul.errorlist');
    if (existingErrorMessage.length > 0) {
      existingErrorMessage.remove();
    }
  },

  changeFormCheckbox(event) {
    const value = $(this.ui[event.currentTarget.name]).is(':checked');

    this.model.set(event.currentTarget.id, value);
  },

  saveClicked() {
    this.ui.create_account.prop('disabled', 'disabled');
    this.clearErrorMessages();

    const enteredCostcentreCode = this.ui.code.val();

    if (this.listOfTakenCodes.includes(enteredCostcentreCode)) {
      this.addErrorMessage('This account code has already been used and is not unique', this.ui.code);
      return;
    }

    // add JWT to header
    $.ajaxSetup({
      headers: {
        accept: 'application/json',
        Authorization: `JWT ${this.getOption('token')}`
      }
    });

    var that = this;

    const groups = _.map(this.selected_collection.models, (group) => {
      return group.id;
    });

    this.model.set('groups', groups);

    this.model.save(null, {
      success(model) {
        that.trigger('saveAccount', model);
      },
      error(_, response) {
        for (const field in response.responseJSON) {
          const thisElement = that.ui[field];

          that.removeExistingFieldErrorMessage(thisElement);

          const error = response.responseJSON[field];

          const errorMessage = `
          <ul class="errorlist">
            <li>${error}</li>
          </ul>`;

          thisElement.parent().append(errorMessage);
        }
      }
    });
  }
});



export const ReceiptAccountsView = Marionette.LayoutView.extend({
  template: require('../../templates/manage_accounts_btn.html'),

  ui: {
    manage_button: '#manage-accounts-button',
    costcentre_selector: '#id_costcentre'
  },

  events: {
    'click @ui.manage_button': 'manageAccounts',
  },

  manageAccounts(event) {
    event.preventDefault();

    const importConfirmView = new ImportConfirmView(this.options);
      const dialog = DialogService.show(importConfirmView);

      dialog.on('close', () => {
        dialog.close();
      });
      importConfirmView.on('saveAccount', model => {
        const costcentre_selector = $(this.ui.costcentre_selector.selector);

        costcentre_selector.append(
          '<option value="' + model.get('id') + '">' +
            model.get('code')  + ' ' +
            model.get('name')  +
            ' (' + model.get('opening_balance')  + ')</option>');

        costcentre_selector.val(model.get('id'));

        dialog.close();
      });

  }
});



// WEBPACK FOOTER //
// ./receipt/views/accounts/index.js